module.exports = __webpack_public_path__ + "static/media/CottonGreen.b2b65bd0.svg";